import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import PhoneInput, {
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import utils from "utils";
import api from "utils/api";
import "./Vendor.scss";
import "react-phone-number-input/style.css";
const MyForm = ({ initialValues, title = "Add Vendor", refreshVendorList }) => {
  const [form] = Form.useForm();
  const [value, setValue] = useState(
    initialValues
      ? `${initialValues?.country_code}${initialValues?.contact_number}`
      : "+91"
  );
  const [buttonLoad, setButtonLoader] = useState(false);
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        contact_number: `${initialValues.country_code}${initialValues.contact_number}`,
      });
    }
  }, [initialValues]);

  const onFinish = (values) => {
    setButtonLoader(true);
    let payload = {
      ...values,
      contact_number: formatPhoneNumberIntl(values.contact_number)
        .split(" ")
        .slice(1)
        .join(""),
      country_code: formatPhoneNumberIntl(values.contact_number).split(" ")[0],
      patient_vendor_id: initialValues?.patient_vendor_id || "",
    };
    api
      .saveVendorDetails(payload)
      .then((response) => {
        if (response.data?.status === 200) {
          message.success(response.data?.message);
          refreshVendorList();
          utils.Modal(false);
        } else {
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };

  return (
    <Card title={title} className="VendorDetailForm">
      <Form
        form={form}
        name="myForm"
        onFinish={onFinish}
        layout="horizontal"
        labelAlign="left"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        colon={false}
      >
        <Form.Item
          name="name"
          label="Vendor"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="contact_name"
          label="Representative"
          rules={[
            { required: true, message: "Please input the contact name!" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="contact_number"
          label="Contact NO."
          style={{ width: "100%" }}
          rules={[
            { required: true, message: "" },
            {
              required: true,
              validator: (_, value) =>
                value
                  ? isValidPhoneNumber(value)
                    ? Promise.resolve()
                    : Promise.reject("Please enter a valid mobile number")
                  : Promise.reject(`Please enter mobile number`),
            },
          ]}
        >
          <div className="mobile-input">
            <PhoneInput
              className="signup-mobile-input"
              international={true}
              defaultCountry="IN"
              value={value}
              onChange={setValue}
            />
          </div>
        </Form.Item>

        <Form.Item
          name="email_id"
          label="Email ID"
          rules={[
            // { required: true, message: "Please input your email!" },
            { type: "email", message: "The input is not valid E-mail!" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="address"
          label="Address"
          //   rules={[{ required: true, message: "Please input your address!" }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          name="GSTIN_number"
          label="GSTIN Number"
          rules={
            [
              // { required: true, message: "Please input your GSTIN number!" },
            ]
          }
        >
          <Input />
        </Form.Item>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "5px",
          }}
        >
          <Form.Item>
            <Button
              loading={buttonLoad}
              type="default"
              onClick={() => {
                utils.Modal(false);
              }}
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              loading={buttonLoad}
              htmlType="submit"
              style={{ background: "#12005F", color: "white" }}
            >
              Submit
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Card>
  );
};

export default MyForm;
